/* eslint react-hooks/immutability: ["warn"] */
/* eslint react-hooks/set-state-in-effect: ["warn"] */
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import { useParams } from "react-router";
import { useCallback, useMemo } from "react";
import LinkbarLoading from "@coworker/apprestructured/src/shared/components/Linkbar/LinkbarLoading";
import TaskCard from "@coworker/apprestructured/src/task-management/components/TaskCard/TaskCard";
import ListableTaskCardWrapper from "@coworker/apprestructured/src/task-management/components/TaskCard/wrappers/NormalTaskWrapper/ListableTaskCardWrapper";
import FixaHelperText from "@coworker/apprestructured/src/shared/wrappers/FixaHelperText/FixaHelperText";
import {
  isLoading,
  LOADING,
} from "@coworker/apprestructured/src/task-management/loading";
import useSearchParamState from "@coworker/apprestructured/src/shared/hooks/useSearchParamState";
import { useTask } from "@coworker/apprestructured/src/task-management/services/useTask";
import { useCreateTitle } from "@coworker/apprestructured/src/task-management/services/useCreateTitle";

function TaskCardPage() {
  const { id: taskId } = useParams();
  const { data: task, isLoading: isLoadingTask } = useTask(taskId!);

  const title = useCreateTitle(task);

  const linkbar = useMemo(() => {
    if (isLoadingTask || !task || isLoading(title)) {
      return <LinkbarLoading />;
    } else if (task) {
      return <Linkbar currentAsH1 currentLabel={title} />;
    } else {
      return <Linkbar currentAsH1 currentLabel="Task not found" />;
    }
  }, [isLoadingTask, task, title]);

  const [, setSearchParams] = useSearchParamState();

  const handleClick = useCallback(() => {
    if (task) {
      setSearchParams((params) => {
        params.set("taskViewer", String(task.id));
      });
    }
  }, [setSearchParams, task]);

  const content = useMemo(() => {
    if (!isLoadingTask && !task) {
      return <FixaHelperText shouldValidate>Task not found</FixaHelperText>;
    } else {
      return (
        <ListableTaskCardWrapper onSelect={task ? handleClick : undefined}>
          <TaskCard task={task || LOADING} />
        </ListableTaskCardWrapper>
      );
    }
  }, [handleClick, isLoadingTask, task]);

  return (
    <>
      {linkbar}
      {content}
    </>
  );
}

export default TaskCardPage;
